import React from "react";

function Header() {
  return (
    <header className="header">
      <h1 className="">React Quiz</h1>
    </header>
  );
}

export default Header;
